import { createAction } from '../libs/redux/saga'
export const ISLOGGED = "ISLOGGED";
export const FORGOT = "FORGOT";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
//---------------------------------
export const DASHBOARD = "DASHBOARD";
export const ROLE = "ROLE";
export const ROLEALL = "ROLEALL";
export const USERROLE = "USERROLE";
export const USERROLEALL = "USERROLEALL";
export const PERMISSION = "PERMISSION";
export const SETTINGS = "SETTINGS";
export const USER = "USER";
export const USERALL = "USERALL";


export const REPO = "REPO";
export const REPOALL = "REPOALL";
export const COMMIT = "COMMIT";
export const COMMITALL = "COMMITALL";
export const PACKAGE = "PACKAGE";
export const PACKAGEALL = "PACKAGEALL";
export const HISTORYALL = "HISTORYALL";

export const REQUESTS = {
    ...createAction(LOGIN, "token", { loader: true }),
    ...createAction(LOGOUT, "token", {}),
    ...createAction(ISLOGGED, "token", {}),
    // ---  Do not update above code----
    ...createAction(DASHBOARD, "dashboard", {}),
    ...createAction(ROLE, "group", {}),
    ...createAction(ROLEALL, "group", {}),
    ...createAction(USERROLE, "user/group", {}),
    ...createAction(USERROLEALL, "user/group", {}),
    ...createAction(PERMISSION, "permission", {}),
    ...createAction(SETTINGS, "settings", {}),
    ...createAction(FORGOT, "public/forgotpassword", {}),
    ...createAction(USER, "user", {}),
    ...createAction(USERALL, "user", {}),

    ...createAction(DASHBOARD, "dashboard", {}),
    ...createAction(REPO, "repo", {}),
    ...createAction(REPOALL, "repo", {}),
    ...createAction(PACKAGE, "package", {}),
    ...createAction(PACKAGEALL, "package", {}),
    ...createAction(COMMIT, "commit", {}),
    ...createAction(COMMITALL, "commit", {}),
    ...createAction(HISTORYALL, "file_history", {}),
}
